import { BONUS_STEP_CONDITIONS, FILTER_GAMES } from 'src/common/dictionary'

export function isBonusGamesAvailable(activeStep, activeUserProgram) {
  if (!activeStep) {
    return false
  }

  const isCasinoSection = activeUserProgram?.program?.section === 0
  const isTurnoverStep = activeStep.condition === BONUS_STEP_CONDITIONS.TURNOVER
  const isCasinoBonusGamesStep =
    activeStep.condition === 4 || activeStep.condition === BONUS_STEP_CONDITIONS.VAGER_BY_BONUS_BALANCE
  const isOnlySport = activeStep.filters?.some((item) => item.type === FILTER_GAMES.ONLY_SPORT)

  return !isOnlySport && (isTurnoverStep || (isCasinoSection && isCasinoBonusGamesStep))
}
